/**
 * Created by fky on 3/13/2017.
 */
(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .directive('noAuthorize', function () {
      return {
        restrict: 'E',
        templateUrl: 'components/common/directives/noAuthorize.tpl.html',
        replace: true,
        link: function (scope) {
          scope.$parent.isWidgetPreInitFinished = true; // disable the PreInit animation;
        }
      };
    });
})();





// WEBPACK FOOTER //
// ./.tmp/components/common/directives/noAuthorizeDirective.js